__turbopack_context__.v({
  "helios-faq": "LcRJNG_helios-faq",
  "helios-faq--compact": "LcRJNG_helios-faq--compact",
  "helios-faq--large": "LcRJNG_helios-faq--large",
  "helios-faq__body": "LcRJNG_helios-faq__body",
  "helios-faq__header": "LcRJNG_helios-faq__header",
  "helios-faq__header--open": "LcRJNG_helios-faq__header--open",
  "helios-faq__heading": "LcRJNG_helios-faq__heading",
  "helios-faq__item": "LcRJNG_helios-faq__item",
  "helios-faq__list": "LcRJNG_helios-faq__list",
});
